<template>
  <VGridItemLayout :item="item" id-key="uniqueOrderID">
    <template #name>
      {{ item.label1 }}
      <!-- #D361 -->
    </template>
    <template #type>
      {{ item.label2 }}
      <!-- #S578 -->
    </template>
    <template #creationDate>
      {{ item.label3 }}
      <!-- #D362 -->
    </template>
    <template #dueDate>
      {{ formatDateTime(item.label4) }}
      <!-- #D363 -->
    </template>
    <template #state>
      {{ item.label5 }}
      <!-- #S579 -->
    </template>

    <template #details>
      <VDetailBoxWrapper gray tag="ul">
        <VDetailBox v-if="item.uniqueSubscriptionId" tag="li">
          <VDescriptionListDividedHorizontal v-if="item.targetUniqueSubscriptionId">
            <VEntry name="order.new_subscriptionid_label">
              <router-link class="offset-top-1" :to="redirectToStockOverview(item.targetUniqueSubscriptionId)">
                {{ item.targetUniqueSubscriptionId }}
              </router-link>
            </VEntry>
            <VEntry name="order.old_subscriptionid_label">
              <router-link class="offset-top-1" :to="redirectToStockOverview(item.uniqueSubscriptionId)">
                {{ item.uniqueSubscriptionId }}
              </router-link>
            </VEntry>
          </VDescriptionListDividedHorizontal>
          <VDescriptionList v-else>
            <VEntry name="order.subscriptionid_label">
              <router-link class="offset-top-1" :to="redirectToStockOverview(item.uniqueSubscriptionId)">
                {{ item.uniqueSubscriptionId }}
              </router-link>
            </VEntry>
          </VDescriptionList>
        </VDetailBox>
        <VDetailBox tag="li">
          <VDescriptionList>
            <VEntry :data="item" field="uniqueOrderID" name="order.uniqueid_label" />
          </VDescriptionList>
        </VDetailBox>
        <VDetailBox v-if="item.identifierValue" tag="li">
          <VDescriptionListDividedHorizontal v-if="item.targetIdentifierValue">
            <VEntry :data="item" field="targetIdentifierValue" name="order.new_contractid_label" />
            <VEntry :data="item" field="identifierValue" name="order.old_contractid_label" />
          </VDescriptionListDividedHorizontal>
          <VDescriptionList v-else>
            <VEntry :data="item" field="identifierValue" name="order.contractid_label" />
          </VDescriptionList>
        </VDetailBox>
        <VDetailBox v-if="item.kdnr" tag="li">
          <VDescriptionListDividedHorizontal v-if="item.targetKdnr">
            <VEntry :data="item" field="targetKdnr" name="order.new_kdnr_label" />
            <VEntry :data="item" field="kdnr" name="order.old_kdnr_label" />
          </VDescriptionListDividedHorizontal>
          <VDescriptionList v-else>
            <VEntry :data="item" field="kdnr" name="order.kdnr_label" />
          </VDescriptionList>
        </VDetailBox>
        <VDetailBox v-if="regUrl" :width="regUrl.length > 50 ? 2 : 1" tag="li">
          <VDescriptionList>
            <VEntry name="order.attribute_regUrl">
              {{ regUrl }}
            </VEntry>
          </VDescriptionList>
        </VDetailBox>
        <VDetailBox v-if="vCode" tag="li">
          <VDescriptionList>
            <VEntry :value="vCode" name="order.attribute_vCode" />
          </VDescriptionList>
        </VDetailBox>
      </VDetailBoxWrapper>

      <VDetailBoxWrapper>
        <VDetailBox>
          <template #headline>
            {{ $t('order.processing_information') }}
          </template>
          <template #default>
            <VDescriptionList>
              <VEntryDate :data="item" field="orderTime" name="order.creationDate_label" />
              <VEntry v-if="item.targetSubscriptionTemplateId" :data="item" field="targetSubscriptionTemplateId" name="order.new_templateid_label" />
              <VEntry v-if="item.targetSubscriptionTemplateId" :data="item" field="targetSubscriptionTemplateName" name="order.new_templatename_label" />
              <VEntry v-if="item.targetSubscriptionTemplateId" :data="item" field="subscriptionTemplateId" name="order.old_templateid_label" />
              <VEntry v-if="item.targetSubscriptionTemplateId" :data="item" field="subscriptionTemplateName" name="order.old_templatename_label" />
              <VEntry :data="item" field="stateChangeReason" name="order.reason_label" />
              <VEntry :data="item" field="stateChangeInfoText" name="order.information_label" />
              <VEntry v-if="!item.targetSubscriptionTemplateId" :data="item" field="subscriptionTemplateName" name="order.templateid_label">
                {{ item.subscriptionTemplateId }}
              </VEntry>
              <VEntryDate :data="item" field="gracePeriodEnd" name="order.graceperiod_label" />
            </VDescriptionList>
          </template>
        </VDetailBox>

        <VDetailBox>
          <template #headline>
            {{ $t('order.other_attributes') }}
          </template>
          <template #default>
            <VDescriptionList>
              <VEntryDate v-for="(desc, index) in otherAttributes" :key="index" :name="translate(desc.name)" :value="desc.value" />
            </VDescriptionList>
          </template>
        </VDetailBox>

        <VDetailBox>
          <template #headline>
            {{ $t('order.registration_activation') }}
          </template>
          <template #default>
            <VDescriptionList>
              <VEntryDate v-for="(desc, index) in registrationActivation" :key="index" :name="translate(desc.name)" :value="desc.value" />
            </VDescriptionList>
          </template>
        </VDetailBox>
      </VDetailBoxWrapper>

      <VDetailBoxWrapper gray>
        <VHistory :subscriber-identifier-type="item.identifierType" :unique-order-id="item.uniqueOrderID" />
      </VDetailBoxWrapper>

      <VOrderOverviewButtons :item="item" />
    </template>
  </VGridItemLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import VDescriptionList from '@/components/DescriptionList';
import VDescriptionListDividedHorizontal from '@/components/DescriptionList/DividedHorizontal';
import VEntry from '@/components/DescriptionList/Entry';
import VEntryDate from '@/components/DescriptionList/EntryDate';
import { formatDateTime } from '@/utils/date';
import { ERROR, STOCK } from '@route-types';
import VGridItemLayout from './Grid/ItemLayout';
import VOrderOverviewButtons from './Buttons';

const REG_URL = 'regUrl';
const V_CODE = 'vCode';
const REGISTRATION = ['regDate', 'redDate', 'actDate', 'devClass', 'serialNo', 'qcUserId'];

export default {
  name: 'OrderOverviewItem',

  components: {
    VGridItemLayout,
    VDescriptionList,
    VDescriptionListDividedHorizontal,
    VEntry,
    VEntryDate,
    VOrderOverviewButtons,
    VDetailBoxWrapper: () => import('@/components/UI/DetailBox/Wrapper'),
    VDetailBox: () => import('@/components/UI/DetailBox'),
    VHistory: () => import('./History'),
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('system', ['hasAccessStockOverview']),

    otherAttributes() {
      return this.item.descriptions.filter(i => ![REG_URL, V_CODE, ...REGISTRATION].includes(i.name));
    },

    registrationActivation() {
      return this.item.descriptions.filter(i => REGISTRATION.includes(i.name));
    },

    regUrl() {
      return this.item.descriptions.find(i => [REG_URL].includes(i.name))?.value;
    },

    vCode() {
      return this.item.descriptions.find(i => [V_CODE].includes(i.name))?.value;
    },
  },

  methods: {
    formatDateTime,

    redirectToStockOverview(uniqueSubscriptionId) {
      if (this.hasAccessStockOverview) {
        return {
          name: STOCK,
          params: { uniqueSubscriptionId: uniqueSubscriptionId },
        };
      } else {
        return { name: ERROR, params: { code: 'CANCEL_TARGET_DIALOGUE_NOT_ALLOWED' } };
      }
    },

    translate(name) {
      return this.$tm('order.attribute_', name);
    },
  },
};
</script>
